import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const trendRTK = createApi({
  reducerPath: "trend_slice",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: [
    "bondScoreTrend",
    "ghostConsumersTrend",
    "missingRevenueTrend",
    "opportunitiesTrend",
    "secondaryConsumersTrend",
  ],
  endpoints: (build) => ({
    getBondScoreTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/bond_score/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["bondScoreTrend"],
    }),
    getGhostConsumersTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/ghost_consumer/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["ghostConsumersTrend"],
    }),
    getMissingEarningsTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_earnings/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["missingRevenueTrend"],
    }),
    getProductOpportunitiesTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/product_opportunities/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["opportunitiesTrend"],
    }),
    getDepositOpportunitiesTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/deposit_opportunities/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["depositOpportunitiesTrend"],
    }),
  }),
});

export const {
  useGetBondScoreTrendQuery,
  useGetMissingEarningsTrendQuery,
  useGetProductOpportunitiesTrendQuery,
  useGetDepositOpportunitiesTrendQuery
} = trendRTK;
